import React, { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import usePermissionCheckerQuery from '../hooks/usePermissionCheckerQuery';
import { PermissionCollection } from '../types';

interface PermissionCheckerProps {
  requiredPermissions: PermissionCollection['codename'][];
  operation?: 'and' | 'or';
  redirectTo?: string;
}

const PermissionChecker: React.FC<PermissionCheckerProps> = ({
  requiredPermissions,
  children,
  redirectTo,
  operation,
}) => {
  const permissionChecker = usePermissionCheckerQuery(requiredPermissions, operation);

  if (permissionChecker.data) {
    return children ? (children as ReactElement) : <Outlet />;
  }

  if (permissionChecker.isSuccess && redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return null;
};

export default PermissionChecker;
